<template>
  <div id="init-home-container" class="d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <auth></auth>

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="cmpbk black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <v-card class="mb-2" style="height: 50px; border: 1px solid white">
              <div
                class="pa-4 mb-2 d-flex justify-start"
                style="font-weight: 600"
              >
                <div>TEAM:</div>
                <div
                  id="selteam"
                  style="
                    width: 90%;
                    position: relative;
                    top: -20px;
                    left: 10px; ;
                  "
                >
                  <!-- <v-select
                    :items="[
                      'CAO',
                      'MET1',
                      'MET2',
                      'CORE',
                      '-51-',
                      '-55-',
                      'K9',
                    ]"
                    v-model="team"
                    @change="team_select"
                  ></v-select> -->
                  <v-select
                    :items="[
                      'CAO',
                      'MET1',
                      'MET2',
                      'CORE',
                      '-51-',
                      '-55-',
                      'K9',
                      'CLEAR',
                    ]"
                    v-model="team"
                    @change="team_select"
                  ></v-select>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- begin coa met1 met2 -->
        <v-row
          no-gutters
          v-if="
            team != '-55-' &&
            team != '-51-' &&
            team != 'k9' &&
            team != 'K9' &&
            team != 'CLEAR'
          "
        >
          <v-col cols="12" md="12">
            <!-- Add Entry -->
            <v-expansion-panels id="all-panels" v-model="panels">
              <v-expansion-panel>
                <v-expansion-panel-header @click="add_hdr_click">{{
                  add_entry_titlek9
                }}</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <v-container>
                    <div>
                      <v-row>
                        <v-col cols="12">
                          <add_edit
                            @save_stat="save_stat"
                            @cancel_edit="cancel_edit"
                            :readonly="readonly"
                            :addedit_update_now="addedit_update_now"
                            :incoming_edit="incoming_edit"
                            :source="edit_from"
                            :scrollpos="scrollpos"
                            :edit_on="edit_on"
                            :team="team"
                          ></add_edit>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search -->
              <v-expansion-panel>
                <v-expansion-panel-header>Search</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <search
                    @search="search"
                    @search_clear="search_clear"
                    :update_search_results_27="update_search_results_27"
                    @open_search_results="open_search_results"
                    :lst_grants="lst_grants"
                  ></search>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search Results -->
              <v-expansion-panel
                v-if="lst_search_results.length > 0"
                class="results"
              >
                <v-expansion-panel-header
                  >Search Results/Reporting</v-expansion-panel-header
                >
                <v-expansion-panel-content color="cmpbkinside" class="results">
                  <searchResults
                    :lst_search_results="lst_search_results"
                    :sterm="sterm"
                    @edit="edit_search"
                    @delete_now="delete_now"
                    @view="view_search"
                  ></searchResults>

                  <!-- make search results and recent seperate componants-->
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Recent -->
              <v-expansion-panel class="recent">
                <v-expansion-panel-header>Recent </v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <!-- please do not put in component, layout here -->
                  <recent
                    @edit="edit_recent"
                    @view="view"
                    @open_recent27="open_recent27"
                    :update_recent="update_recent"
                    @delete_now="delete_now"
                  ></recent>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- begin 27 -->
        <v-row no-gutters v-if="team == '-55-' || team == '-51-'">
          <v-col cols="12" md="12">
            <!-- Add Entry -->
            <v-expansion-panels id="all-panels" v-model="panels27">
              <v-expansion-panel>
                <v-expansion-panel-header @click="add_hdr_click">{{
                  add_entry_title27
                }}</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <v-container>
                    <div>
                      <v-row>
                        <v-col cols="12">
                          <add_edit27
                            @save_stat27="save_stat27"
                            @cancel_edit27="cancel_edit27"
                            :readonly="readonly"
                            :addedit_update_now="addedit_update_now27"
                            :incoming_edit="incoming_edit27"
                            :source="edit_from27"
                            :scrollpos="scrollpos"
                            :edit_on="edit_on27"
                            :team="team"
                          ></add_edit27>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search -->
              <v-expansion-panel>
                <v-expansion-panel-header>Search</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <search27
                    @search27="search27"
                    @search_clear="search_clear"
                    :update_search_results_27="update_search_results_27"
                    @open_search_results="open_search_results"
                    :lst_grants="lst_grants"
                  ></search27>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search Results -->
              <v-expansion-panel
                class="results"
                v-if="lst_search_results27.length > 0"
              >
                <v-expansion-panel-header
                  >Search Results/Reporting</v-expansion-panel-header
                >
                <v-expansion-panel-content color="cmpbkinside" class="results">
                  <searchResults27
                    :lst_search_results27="lst_search_results27"
                    :sterm="sterm"
                    @edit="edit_search27"
                    @delete_now27="delete_now27"
                    @view="view_search"
                  ></searchResults27>

                  <!-- make search results and recent seperate componants-->
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Recent -->
              <v-expansion-panel class="recent">
                <v-expansion-panel-header>Recent</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <!-- please do not put in component, layout here -->
                  <recent27
                    @edit="edit_recent27"
                    @view27="view27"
                    @open_recent="open_recent"
                    :update_recent27="update_recent27"
                    @delete_now27="delete_now27"
                  ></recent27>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- !****************************************! -->
        <!-- begin K9 -->
        <v-row no-gutters v-if="team == 'k9' || team == 'K9'">
          <v-col cols="12" md="12">
            <!-- Add Entry -->
            <v-expansion-panels id="all-panels" v-model="panelsk9">
              <v-expansion-panel>
                <v-expansion-panel-header @click="add_hdr_click">{{
                  add_entry_titlek9
                }}</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <v-container>
                    <div>
                      <v-row>
                        <v-col cols="12">
                          <add_editk9
                            @save_statk9="save_statk9"
                            @cancel_editk9="cancel_editk9"
                            :readonly="readonly"
                            :addedit_update_now="addedit_update_nowk9"
                            :incoming_edit="incoming_editk9"
                            :source="edit_fromk9"
                            :scrollpos="scrollpos"
                            :edit_on="edit_onk9"
                            :team="team"
                          ></add_editk9>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search k9-->
              <v-expansion-panel>
                <v-expansion-panel-header>Search</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <searchk9
                    @searchk9="searchk9"
                    @search_cleark9="search_cleark9"
                    :update_search_results_k9="update_search_results_k9"
                    @open_search_results="open_search_results"
                  ></searchk9>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search Results -->
              <v-expansion-panel
                v-if="lst_search_resultsk9.length > 0"
                class="results"
              >
                <v-expansion-panel-header
                  >Search Results/Reporting</v-expansion-panel-header
                >
                <v-expansion-panel-content color="cmpbkinside" class="results">
                  <searchResultsk9
                    :lst_search_resultsk9="lst_search_resultsk9"
                    :sterm="sterm"
                    @edit="edit_searchk9"
                    @delete_nowk9="delete_nowk9"
                    @viewk9="view_search"
                  ></searchResultsk9>

                  <!-- make search results and recent seperate componants-->
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Recent -->
              <v-expansion-panel class="recent">
                <v-expansion-panel-header>Recent</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <!-- please do not put in component, layout here -->
                  <recentk9
                    @edit="edit_recentk9"
                    @viewk9="viewk9"
                    @open_recentk9="open_recentk9"
                    :update_recentk9="update_recentk9"
                    @delete_nowk9="delete_nowk9"
                  ></recentk9>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- begin CLEAR -->
        <v-row no-gutters v-if="team == 'CLEAR'">
          <v-col cols="12" md="12">
            <!-- Add Entry -->
            <v-expansion-panels id="all-panels" v-model="panelsclr">
              <v-expansion-panel>
                <v-expansion-panel-header @click="add_hdr_click">{{
                  add_entry_titleclr
                }}</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <v-container>
                    <div>
                      <v-row>
                        <v-col cols="12">
                          <add_editclr
                            @save_statclr="save_statclr"
                            @cancel_editclr="cancel_editclr"
                            :readonly="readonly"
                            :addedit_update_now="addedit_update_nowclr"
                            :incoming_edit="incoming_editclr"
                            :source="edit_fromclr"
                            :scrollpos="scrollpos"
                            :edit_on="edit_onclr"
                            :team="team"
                          ></add_editclr>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search CLEAR-->
              <v-expansion-panel>
                <v-expansion-panel-header>Search</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <searchclr
                    @searchclr="searchclr"
                    @search_clearclr="search_clearclr"
                    :update_search_results_clr="update_search_results_clr"
                    @open_search_results="open_search_results"
                  ></searchclr>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Search Results -->
              <v-expansion-panel
                v-if="lst_search_resultsclr.length > 0"
                class="results"
              >
                <v-expansion-panel-header
                  >Search Results/Reporting</v-expansion-panel-header
                >
                <v-expansion-panel-content color="cmpbkinside" class="results">
                  <searchResultsclr
                    :lst_search_resultsclr="lst_search_resultsclr"
                    :sterm="sterm"
                    @edit="edit_searchclr"
                    @delete_nowclr="delete_nowclr"
                    @viewclr="view_search"
                  ></searchResultsclr>

                  <!-- make search results and recent seperate componants-->
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Recent -->
              <v-expansion-panel class="recent">
                <v-expansion-panel-header>Recent</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <!-- please do not put in component, layout here -->
                  <recentclr
                    @edit="edit_recentclr"
                    @viewclr="viewclr"
                    @open_recentclr="open_recentclr"
                    :update_recentclr="update_recentclr"
                    @delete_nowclr="delete_nowclr"
                  ></recentclr>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  //.hide-if-large {
  //   display: flex !important;
  // }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import xtabs from "./xtabs.vue";
import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
const add_edit = () => import("./add_edit.vue");
const add_edit27 = () => import("./add_edit27.vue");
const add_editk9 = () => import("./add_editk9.vue");
const add_editclr = () => import("./add_editclr.vue");
const search = () => import("./search.vue");
const search27 = () => import("./search27.vue");
const searchk9 = () => import("./searchk9.vue");
const searchclr = () => import("./searchclr.vue");
const searchResults = () => import("./searchResults.vue");
const searchResults27 = () => import("./searchResults27.vue");
const searchResultsk9 = () => import("./searchResultsk9.vue");
const searchResultsclr = () => import("./searchResultsclr.vue");
const recent = () => import("./recent.vue");
const recent27 = () => import("./recent27.vue");
const recentk9 = () => import("./recentk9.vue");
const recentclr = () => import("./recentclr.vue");

export default {
  name: "Home",
  // components: {
  //   auth,
  //   add_edit,
  //   search,
  //   recent,
  //   searchResults,
  // },
  components: {
    add_edit,
    add_edit27,
    add_editk9,
    add_editclr,
    search,
    search27,
    searchk9,
    searchclr,
    recent,
    recent27,
    recentk9,
    recentclr,
    searchResults,
    searchResultsclr,
    searchResultsk9,
    searchResults27,
    auth,
  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      readonly: false,
      team: "",
      lst_grants: [],
      return_data: {},
      save_stat_data: {},
      sterm: {},
      edit_on: false,
      edit_on27: false,
      edit_onk9: false,
      edit_onclr: false,
      scrollpos: -1,
      source: "",
      dialog: false,
      update_search_results: null,
      update_search_results_27: null,
      update_search_results_k9: null,
      update_search_results_clr: null,
      update_recent: null,
      update_recent27: null,
      update_recentk9: null,
      update_recentclr: null,
      edit_from: "",
      edit_from27: "",
      edit_fromk9: "",
      edit_fromclr: "",
      panelsk9: -1,
      panelsclr: -1,
      panels27: -1,
      panels: -1,
      add_entry_titleclr: "Add Entry",
      add_entry_titlek9: "Add Entry",
      add_entry_title27: "Add Entry",
      add_entry_title: "Add Entry",
      stat_data_newclr: {
        stat_data_Id: 0,
        area: "",
        mission: "",
        cites: 0,
        misdo_arrests: 0,
        gf_arrests: 0,
        vehicle_posted: 0,
        vehicle_towed: 0,
        help_tickets: 0,
        contacts: 0,
      },
      incoming_editclr: null,
      incoming_editk9: null,
      incoming_edit27: null,
      incoming_edit: null,
      //change date (js format) when update is complete to send refesh to child compoenent
      addedit_update_nowclr: 0,
      addedit_update_nowk9: 0,
      addedit_update_now27: 0,
      addedit_update_now: 0,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 60 characters",
      ],
      lst_search_resultsclr: [],
      lst_search_resultsk9: [],
      lst_search_results27: [],
      lst_search_results: [],
      stat_data_newk9: {
        rpd_stat_k9Id: 0,
        team: "",
        stat_date: "",
        area: "DEEDS",
        other_area: "",

        deeds_hours: "0.00",
        area_checks: 0,
        citizen_contacts: 0,
        business_checks_contacts: 0,
        vehicle_checks: 0,
        traffic_subject_stops: 0,
        arrests: 0,

        bomb_sniffs: 0,
        fcc_sniffs: 0,
        missing_person_track: 0,
        narcotic_sniffs: 0,
        suspect_track: 0,

        notes: "",
      },
      stat_data_new27: {
        rpd_stat_27_Id: 0,

        deeds_hours: "0.00",
        patrol_investigations: 0,
        subject_stops: 0,
        gtar: 0,

        planned_operations: 0,
        cfs_handled: 0,
        cfs_handled_reports: 0,
        felony_arrests: 0,

        gross_mido_arrests: 0,
        misdo_arrests: 0,
        rmc_cites: 0,
        traffic_stops: 0,

        traffic_citations: 0,
        warnings: 0,
        area_check: 0,
        business_check: 0,

        bus_contacts: 0,
        citizen_contacts: 0,
        substances_seized: 0,
        firearms_seized: 0,

        vehicle_posted: 0,
        vehicle_towed: 0,
      },
      stat_data: [
        {
          stop_type: "Complaint",
          details:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur suscipit.",
          cites: false,
          stops: true,
          CFS: false,
          arrest: false,
          DUI: false,
          accident: false,
          SRO: false,
          MAIT: false,
          deeds: false,
          s_create: "10/12/2024",
          s_user: "person@reno.gov",
        },
        {
          stop_type: "Dispatch",
          details:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur suscipit.",
          cites: true,
          stops: true,
          CFS: true,
          arrest: true,
          DUI: true,
          accident: true,
          SRO: true,
          MAIT: true,
          deeds: false,
          s_create: "10/12/2024",
          s_user: "person@reno.gov",
        },
        {
          stop_type: "Warrant",
          details:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur suscipit.",
          cites: false,
          stops: false,
          CFS: false,
          arrest: false,
          DUI: true,
          accident: false,
          SRO: false,
          MAIT: false,
          deeds: false,
          s_create: "10/12/2024",
          s_user: "person@reno.gov",
        },
      ],
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  methods: {
    team_select() {
      let self = this;
      console.log("team_select save");
      if (this.team != "") {
        //save user team
        let formIn = {};
        formIn.email = this.$store.state.user.email;
        formIn.token = this.$store.state.user.token;
        formIn.team = this.team;
        formIn.apiname = "save_team_user";

        let self = this;
        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            self.team = data;
            self.panels = 0;
            self.panels27 = 0;
          })
          .catch((msg) => {
            self.dialog = false;
            this.show_loader(false);
            this.swall_it("Error save_team_user", msg, "error", null, null);
          });
      }
    },
    add_hdr_click() {
      setTimeout(() => {
        let self = this;
        if (self.team == "") {
          console.log("panel = -1");
          self.panels = -1;
          self.panels27 = -1;
          self.panelsk9 = -1;
          self.panelsclr = -1;
        }
      }, 300);
    },
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    delete_nowclr(stat, source) {
      // this.mrbreakpoint(stat);
      this.add_entry_title = "Add Entry";
      this.edit_on = false;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.rpd_stat_k9Id = stat.rpd_stat_k9Id;

      formIn.apiname = "delete_nowclr";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (source == "recent") {
            self.addedit_update_nowk9 = new Date();
          }
          self.swall_it("Delete Status", "Completed.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_nowk9(stat, source) {
      // this.mrbreakpoint(stat);
      this.add_entry_title = "Add Entry";
      this.edit_on = false;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.rpd_stat_k9Id = stat.rpd_stat_k9Id;

      formIn.apiname = "delete_nowk9";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (source == "recent") {
            self.addedit_update_nowk9 = new Date();
          }
          self.swall_it("Delete Status", "Completed.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_now27(stat, source) {
      // this.mrbreakpoint(stat);
      this.add_entry_title = "Add Entry";
      this.edit_on = false;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.rpd_stat_27_Id = stat.rpd_stat_27_Id;

      formIn.apiname = "delete_now27";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (source == "recent") {
            self.addedit_update_now27 = new Date();
          }
          self.swall_it("Delete Status", "Completed.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_now(stat, source) {
      // this.mrbreakpoint(stat);
      this.add_entry_title = "Add Entry";
      this.edit_on = false;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.rpd_stat_Id = stat.rpd_stat_Id;

      formIn.apiname = "delete_now";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (source == "recent") {
            self.addedit_update_now = new Date();
          }
          self.swall_it("Delete Status", "Completed.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    open_search_results() {
      this.panels = document.querySelectorAll(".v-expansion-panel").length - 2;
    },
    edit_searchclr(stat) {
      //moves data to add edit form
      this.edit_onclr = true;
      this.incoming_editclr = this.mno(stat);
      //open endit panel
      this.panelsclr = 0;
      this.edit_fromclr = "search";
      this.add_entry_title = "Edit Entry";
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_searchk9(stat) {
      //moves data to add edit form
      this.edit_onk9 = true;
      this.incoming_editk9 = this.mno(stat);
      //open endit panel
      this.panelsk9 = 0;
      this.edit_fromk9 = "search";
      this.add_entry_title = "Edit Entry";
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_search27(stat) {
      //moves data to add edit form
      this.edit_on27 = true;
      this.incoming_edit27 = this.mno(stat);
      //open endit panel
      this.panels27 = 0;
      this.edit_from27 = "search";
      this.add_entry_title = "Edit Entry";
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_search(stat) {
      //moves data to add edit form
      this.edit_on = true;
      this.incoming_edit = this.mno(stat);
      //open endit panel
      this.panels = 0;
      this.edit_from = "search";
      this.add_entry_title = "Edit Entry";
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    search_clear() {
      this.lst_search_results = [];
      this.edit_on = false;
      this.add_entry_title = "Add Entry";
    },
    search_clearclr() {
      this.lst_search_resultsk9 = [];
      this.edit_onk9 = false;
      this.add_entry_titleclr = "Add Entry";
    },
    search_cleark9() {
      this.lst_search_resultslcr = [];
      this.edit_onclr = false;
      this.add_entry_titlek9 = "Add Entry";
    },
    search_clear27() {
      this.lst_search_results27 = [];
      this.edit_on27 = false;
      this.add_entry_title = "Add Entry";
    },
    cancel_editclr(stat) {
      this.show_loader(true);
      //new
      this.readonly = false;

      this.add_entry_titleclr = "Add Entry";
      this.incoming_editclr = this.mno(this.stat_data_newclr);
      this.edit_onclr = false;
      var self = this;
      if (this.edit_fromclr == "recent") {
        this.open_recentclr(function () {
          self.$nextTick(() => {
            setTimeout(function () {
              document
                .getElementById("edt" + stat.rpd_stat_clrId)
                .scrollIntoView(true);
              self.show_loader(false);
            }, 350);
          });
        });
      } else {
        //srch
        //it was search
        this.show_loader(false);
        this.panelsclr = 3;
        self.$nextTick(() => {
          setTimeout(function () {
            this.add_entry_titleclr = "Add Entry";
            document
              .getElementById("srch" + stat.rpd_stat_clrId)
              .scrollIntoView(true);
            self.show_loader(false);
          }, 350);
        });
      }
    },
    cancel_editk9(stat) {
      this.show_loader(true);
      //new
      this.readonly = false;

      this.add_entry_titlek9 = "Add Entry";
      this.incoming_editk9 = this.mno(this.stat_data_newk9);
      this.edit_onk9 = false;
      var self = this;
      if (this.edit_fromk9 == "recent") {
        this.open_recentk9(function () {
          self.$nextTick(() => {
            setTimeout(function () {
              document
                .getElementById("edt" + stat.rpd_stat_k9Id)
                .scrollIntoView(true);
              self.show_loader(false);
            }, 350);
          });
        });
      } else {
        //srch
        //it was search
        this.show_loader(false);
        this.panelsk9 = 3;
        self.$nextTick(() => {
          setTimeout(function () {
            this.add_entry_titlek9 = "Add Entry";
            document
              .getElementById("srch" + stat.rpd_stat_k9Id)
              .scrollIntoView(true);
            self.show_loader(false);
          }, 350);
        });
      }
    },
    cancel_edit27(stat) {
      this.show_loader(true);
      //new
      this.readonly = false;

      this.add_entry_title27 = "Add Entry";
      this.incoming_edit27 = this.mno(this.stat_data_new27);
      this.edit_on27 = false;
      var self = this;
      if (this.edit_from27 == "recent") {
        this.open_recent27(function () {
          self.$nextTick(() => {
            setTimeout(function () {
              document
                .getElementById("edt" + stat.rpd_stat_27_Id)
                .scrollIntoView(true);
              self.show_loader(false);
            }, 350);
          });
        });
      } else {
        //srch
        //it was search
        this.show_loader(false);
        this.panels27 = 3;
        self.$nextTick(() => {
          setTimeout(function () {
            this.add_entry_title27 = "Add Entry";
            document
              .getElementById("srch" + stat.rpd_stat_27_Id)
              .scrollIntoView(true);
            self.show_loader(false);
          }, 350);
        });
      }
    },
    cancel_edit(stat) {
      this.show_loader(true);
      //new
      this.readonly = false;

      this.add_entry_title = "Add Entry";
      this.incoming_edit = this.mno(this.stat_data_new);
      this.edit_on = false;
      var self = this;
      if (this.edit_from == "recent") {
        this.open_recent(function () {
          self.$nextTick(() => {
            setTimeout(function () {
              document
                .getElementById("edt" + stat.rpd_stat_Id)
                .scrollIntoView(true);
              self.show_loader(false);
            }, 350);
          });
        });
      } else {
        //srch
        //it was search
        this.show_loader(false);
        this.panels = 3;
        self.$nextTick(() => {
          setTimeout(function () {
            this.add_entry_title = "Add Entry";
            document
              .getElementById("srch" + stat.rpd_stat_Id)
              .scrollIntoView(true);
            self.show_loader(false);
          }, 350);
        });
      }
    },
    open_recentclr(callback) {
      //callback is to scoll to elemetn last edited
      this.panelsclr =
        document.querySelectorAll(".v-expansion-panel").length - 1;
      if (callback != null) {
        callback();
      }
    },
    open_recentk9(callback) {
      //callback is to scoll to elemetn last edited
      this.panelsk9 =
        document.querySelectorAll(".v-expansion-panel").length - 1;
      if (callback != null) {
        callback();
      }
    },
    open_recent27(callback) {
      //callback is to scoll to elemetn last edited
      this.panels27 =
        document.querySelectorAll(".v-expansion-panel").length - 1;
      if (callback != null) {
        callback();
      }
    },
    open_recent(callback) {
      //callback is to scoll to elemetn last edited
      this.panels = document.querySelectorAll(".v-expansion-panel").length - 1;
      if (callback != null) {
        callback();
      }
    },
    view_search(stat, scrollpos) {
      console.log("view recent");
      this.readonly = true;
      this.edit_on = true;
      this.incoming_edit = this.mno(stat);
      //open endit panel
      this.panels = 0;
      this.edit_from = "search";
      this.add_entry_title = "View Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to View", "", "", null, null);
    },
    viewclr(stat, scrollpos) {
      console.log("viewclr recent");
      this.readonly = true;
      this.edit_onclr = true;
      this.incoming_editclr = this.mno(stat);
      //open endit panel
      this.panelsclr = 0;
      this.edit_fromclr = "recent";
      this.add_entry_titleclr = "View Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to View", "", "", null, null);
    },
    viewk9(stat, scrollpos) {
      console.log("viewk9 recent");
      this.readonly = true;
      this.edit_onk9 = true;
      this.incoming_editk9 = this.mno(stat);
      //open endit panel
      this.panelsk9 = 0;
      this.edit_fromk9 = "recent";
      this.add_entry_titlek9 = "View Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to View", "", "", null, null);
    },
    view27(stat, scrollpos) {
      console.log("view27 recent");
      this.readonly = true;
      this.edit_on27 = true;
      this.incoming_edit27 = this.mno(stat);
      //open endit panel
      this.panels27 = 0;
      this.edit_from27 = "recent";
      this.add_entry_title27 = "View Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to View", "", "", null, null);
    },
    view(stat, scrollpos) {
      console.log("view recent");
      this.readonly = true;
      this.edit_on = true;
      this.incoming_edit = this.mno(stat);
      //open endit panel
      this.panels = 0;
      this.edit_from = "recent";
      this.add_entry_title = "View Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to View", "", "", null, null);
    },
    edit_recentclr(stat, scrollpos) {
      this.mrbreakpoint("edit_recentclr");
      this.readonly = false;
      this.edit_onclr = true;
      this.incoming_editclr = this.mno(stat);
      //open endit panel
      this.panelsclr = 0;
      this.edit_fromclr = "recent";
      this.add_entry_titleclr = "Edit Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_recentk9(stat, scrollpos) {
      this.mrbreakpoint("edit_recentk9");
      this.readonly = false;
      this.edit_onk9 = true;
      this.incoming_editk9 = this.mno(stat);
      //open endit panel
      this.panelsk9 = 0;
      this.edit_fromk9 = "recent";
      this.add_entry_titlek9 = "Edit Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_recent27(stat, scrollpos) {
      this.mrbreakpoint("edit_recentk27");
      this.readonly = false;
      this.edit_on27 = true;
      this.incoming_edit27 = this.mno(stat);
      //open endit panel
      this.panels27 = 0;
      this.edit_from27 = "recent";
      this.add_entry_title27 = "Edit Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    edit_recent(stat, scrollpos) {
      this.mrbreakpoint("edit_recent");
      this.readonly = false;
      this.edit_on = true;
      this.incoming_edit = this.mno(stat);
      //open endit panel
      this.panels = 0;
      this.edit_from = "recent";
      this.add_entry_title = "Edit Entry";
      this.scrollpos = scrollpos;
      this.swall_it("Ready to Edit", "", "", null, null);
    },
    searchclr(param_sterm) {
      this.lst_search_resultsclr = [];
      this.panelsclr = 0;
      this.show_loader(true);
      var sterm = this.mno(param_sterm);

      this.$store.commit("set_sterm", this.mno(sterm));
      //reverser all
      this.sterm = sterm;

      //for the reprots
      this.sterm.noterms = false;
      var self = this;
      sterm.all = !sterm.all;
      this.show_loader(true);
      //validate serach range

      if (sterm.frm_date == "None" || sterm.frm_date == "") {
        sterm.frm_date = "1/1/1900";
      }
      if (sterm.to_date == "None" || sterm.to_date == "") {
        sterm.to_date = "1/1/1900";
      }

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = sterm;

      formIn.apiname = "search_rpd_statclr";
      this.show_loader(true);
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data.length > 0) {
            //  self.mrbreakpoint("search");
            self.show_loader(true);
            self.panelsclr = 0;
            self.show_loader(true);
            var lst = this.mno(data);
            console.log("data lst len: " + lst.length);
            // for (let index = 0; index < lst.length; index++) {
            //   var stat = lst[index];
            //   stat.mil_time = this.frm_jsDate_toMilTime(stat.s_date);
            // }
            self.lst_search_resultsclr = self.mno(lst);
            self.$nextTick(() => {
              self.panelsclr = 3;
              //  this.show_loader(false);
            });
            this.show_loader(true);
            if (self.edit_fromclr != "search_updated") {
              //   this.show_loader(false);
              this.swall_it(
                "Search Status",
                "Complete " + data.length + " items found.",
                "sucess",
                null,
                null
              );
              self.$store.commit(
                "set_gbl_report_dataclr",
                self.lst_search_resultsclr
              );
            } else {
              self.edit_fromclr = "";
              //this.show_loader(false);
            }
          } else {
            self.panelsclr = 1;
            this.show_loader(false);
            this.swall_it(
              "Search Status",
              "No items were found. Please change your search cirteria and try again.",
              "sucess",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    searchk9(param_sterm) {
      this.lst_search_resultsk9 = [];
      this.panelsk9 = 0;
      this.show_loader(true);
      var sterm = this.mno(param_sterm);

      this.$store.commit("set_sterm", this.mno(sterm));
      //reverser all
      this.sterm = sterm;

      //for the reprots
      this.sterm.noterms = false;
      var self = this;
      sterm.all = !sterm.all;
      this.show_loader(true);
      //validate serach range

      if (sterm.frm_date == "None" || sterm.frm_date == "") {
        sterm.frm_date = "1/1/1900";
      }
      if (sterm.to_date == "None" || sterm.to_date == "") {
        sterm.to_date = "1/1/1900";
      }

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = sterm;

      formIn.apiname = "search_rpd_statk9";
      this.show_loader(true);
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data.length > 0) {
            //  self.mrbreakpoint("search");
            self.show_loader(true);
            self.panelsk9 = 0;
            self.show_loader(true);
            var lst = this.mno(data);
            console.log("data lst len: " + lst.length);
            for (let index = 0; index < lst.length; index++) {
              var stat = lst[index];
              stat.mil_time = this.frm_jsDate_toMilTime(stat.s_date);
            }
            self.lst_search_resultsk9 = self.mno(lst);
            self.$nextTick(() => {
              self.panelsk9 = 3;
              //  this.show_loader(false);
            });
            this.show_loader(true);
            if (self.edit_fromk9 != "search_updated") {
              //   this.show_loader(false);
              this.swall_it(
                "Search Status",
                "Complete " + data.length + " items found.",
                "sucess",
                null,
                null
              );
              self.$store.commit(
                "set_gbl_report_datak9",
                self.lst_search_results27
              );
            } else {
              self.edit_from = "";
              //this.show_loader(false);
            }
          } else {
            this.show_loader(false);
            this.swall_it(
              "Search Status",
              "No items were found. Please change your search cirteria and try again.",
              "sucess",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    search27(param_sterm) {
      this.lst_search_results27 = [];
      this.panels27 = 0;
      this.show_loader(true);
      var sterm = this.mno(param_sterm);

      this.$store.commit("set_sterm", this.mno(sterm));
      //reverser all
      this.sterm = sterm;

      //for the reprots
      this.sterm.noterms = false;
      var self = this;
      sterm.all = !sterm.all;
      this.show_loader(true);
      //validate serach range

      if (sterm.frm_date == "None" || sterm.frm_date == "") {
        sterm.frm_date = "1/1/1900";
      }
      if (sterm.to_date == "None" || sterm.to_date == "") {
        sterm.to_date = "1/1/1900";
      }

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = sterm;

      formIn.apiname = "search_rpd_stat27";
      this.show_loader(true);
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data.length > 0) {
            //  self.mrbreakpoint("search");
            self.show_loader(true);
            self.panels27 = 0;
            self.show_loader(true);
            var lst = this.mno(data);
            console.log("data lst len: " + lst.length);
            for (let index = 0; index < lst.length; index++) {
              var stat = lst[index];
              stat.mil_time = this.frm_jsDate_toMilTime(stat.s_date);
            }
            self.lst_search_results27 = self.mno(lst);
            self.$nextTick(() => {
              self.panels27 = 3;
              //  this.show_loader(false);
            });
            this.show_loader(true);
            if (self.edit_from27 != "search_updated") {
              //   this.show_loader(false);
              this.swall_it(
                "Search Status",
                "Complete " + data.length + " items found.",
                "sucess",
                null,
                null
              );
              self.$store.commit(
                "set_gbl_report_data27",
                self.lst_search_results27
              );
            } else {
              self.edit_from = "";
              //this.show_loader(false);
            }
          } else {
            this.show_loader(false);
            this.swall_it(
              "Search Status",
              "No items were found. Please change your search cirteria and try again.",
              "sucess",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    search(param_sterm) {
      this.lst_search_results = [];
      this.panels = 0;
      this.show_loader(true);
      var sterm = this.mno(param_sterm);

      this.$store.commit("set_sterm", this.mno(sterm));
      //reverser all
      this.sterm = sterm;

      //for the reprots
      this.sterm.noterms = false;
      var self = this;
      sterm.all = !sterm.all;
      this.show_loader(true);
      //validate serach range

      if (sterm.frm_date == "None" || sterm.frm_date == "") {
        sterm.frm_date = "1/1/1900";
      }
      if (sterm.to_date == "None" || sterm.to_date == "") {
        sterm.to_date = "1/1/1900";
      }

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = sterm;

      formIn.apiname = "search_rpd_stat";
      this.show_loader(true);
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data.length > 0) {
            //  self.mrbreakpoint("search");
            self.show_loader(true);
            self.panels = 0;
            self.show_loader(true);
            var lst = this.mno(data);
            console.log("data lst len: " + lst.length);
            for (let index = 0; index < lst.length; index++) {
              var stat = lst[index];
              stat.mil_time = this.frm_jsDate_toMilTime(stat.s_date);
            }
            self.lst_search_results = self.mno(lst);
            self.$nextTick(() => {
              self.panels = 3;
              //  this.show_loader(false);
            });
            this.show_loader(true);
            if (self.edit_from != "search_updated") {
              //   this.show_loader(false);
              this.swall_it(
                "Search Status",
                "Complete " + data.length + " items found.",
                "sucess",
                null,
                null
              );
              self.$store.commit(
                "set_gbl_report_data",
                self.lst_search_results
              );
            } else {
              self.edit_from = "";
              //this.show_loader(false);
            }
          } else {
            this.show_loader(false);
            this.swall_it(
              "Search Status",
              "No items were found. Please change your search cirteria and try again.",
              "sucess",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    save_statk9(stat_data) {
      //stat date k9!

      stat_data.deeds_hours = parseFloat(stat_data.deeds_hours);
      this.save_stat_data = stat_data;
      console.log("home notes: " + stat_data.notes);
      console.log("home hours worked: " + stat_data.deeds_hours);

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.FrmStats = stat_data;

      formIn.apiname = "save_statk9";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          this.mrbreakpoint("save_stat k9");
          this.addedit_update_nowk9 = new Date();
          self.update_recentk9 = new Date();
          self.edit_onk9 = false;
          this.add_entry_title = "Add Entry";

          //open panel
          if (self.edit_fromk9 == "recent") {
            self.panelsk9 = 2;
            self.edit_fromk9 = "";
            self.add_entry_titlek9 = "Add Entry";
            this.addedit_update_nowk9 = new Date();
          }

          if (self.edit_fromk9 == "search") {
            self.panelsk9 = 1;
            self.edit_fromk9 = "search_updated";
            self.update_search_results_k9 = new Date();

            self.add_entry_title = "Add Entry";
            self.addedit_update_nowk9 = new Date();
          }
          this.swall_it(
            "Submit Satus",
            "Submission Recorded",
            "sucess",
            null,
            null
          );
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saveing", msg, "error", null, null);
        });
    },
    save_stat27(stat_data) {
      //stat date 27!
      //this.mrbreakpoint("save_stat 2");
      stat_data.deeds_hours = parseFloat(stat_data.deeds_hours);
      this.save_stat_data = stat_data;
      console.log("home notes: " + stat_data.notes);
      console.log("home hours worked: " + stat_data.deeds_hours);

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.FrmStats = stat_data;

      formIn.apiname = "save_stat27";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          this.addedit_update_now27 = new Date();
          self.update_recent27 = new Date();
          self.edit_on27 = false;
          this.add_entry_title27 = "Add Entry";

          //open panel
          if (self.edit_from_27 == "recent") {
            self.edit_from = "";
            self.add_entry_title = "Add Entry";
            this.addedit_update_now = new Date();
          }

          if (self.edit_from27 == "search") {
            self.panels27 = 1;
            self.edit_from27 = "search_updated";
            self.update_search_results_27 = new Date();

            self.add_entry_title27 = "Add Entry";
            self.addedit_update_now27 = new Date();
          }
          this.swall_it(
            "Submit Satus",
            "Submission Recorded",
            "sucess",
            null,
            null
          );
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saveing", msg, "error", null, null);
        });
    },
    save_statclr(stat_data) {
      //this.mrbreakpoint("save_stat 2");

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.FrmStats = stat_data;

      formIn.apiname = "save_statclr";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          this.addedit_update_nowclr = new Date();
          self.update_recentclr = new Date();
          self.edit_onclr = false;
          this.add_entry_titleclr = "Add Entry";

          //open panel
          if (self.edit_from_clr == "recent") {
            self.edit_from = "";
            self.add_entry_title = "Add Entry";
            this.addedit_update_nowclr = new Date();
          }

          if (self.edit_fromclr == "search") {
            self.panelsclr = 1;
            self.edit_fromclr = "search_updated";
            self.update_search_results_clr = new Date();

            self.add_entry_titleclr = "Add Entry";
            self.addedit_update_nowclr = new Date();
          }
          this.swall_it(
            "Submit Satus",
            "Submission Recorded",
            "sucess",
            null,
            null
          );
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saveing", msg, "error", null, null);
        });
    },
    save_stat(stat_data) {
      // console.log("stat_data: " + stat_data.arrest);
      this.save_stat_data = stat_data;
      console.log("home notes: " + stat_data.notes);
      console.log("home hours worked: " + stat_data.hours_worked);

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.FrmStats = stat_data;

      formIn.apiname = "save_rpd_stat";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          this.addedit_update_now = new Date();
          self.update_recent = new Date();
          self.edit_on = false;
          this.add_entry_title = "Add Entry";
          //open panel
          if (self.edit_from == "recent") {
            self.edit_from = "";
            self.add_entry_title = "Add Entry";
            this.addedit_update_now = new Date();
          }

          if (self.edit_from == "search") {
            self.edit_from = "search_updated";
            this.update_search_results = new Date();
            self.add_entry_title = "Add Entry";
            this.addedit_update_now = new Date();
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saveing", msg, "error", null, null);
        });
    },
    get_user_team() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_user_team";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          self.team = data;
          if (self.team != "") {
            self.panels = 0;
            self.panels27 = 0;
            self.panelsk9 = 0;
            self.panelsclr = 0;
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_user_team", msg, "error", null, null);
        });
    },
    init(self) {
      this.get_user_team();

      this.show_loader(false);
    },
  },
  mounted() {
    // fake user login
    // var user = {
    //   email: "jvonmolt@gmail.com",
    //   roles: "stat-admin",
    //   token: "myverylongandencryptedtoken",
    //   rpduserId: 42,
    //   auth: true,
    // };
    // this.$store.commit("setUser", user);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
